import { calculateDistance } from './dayLegs';

export interface TodayStoreRef {
  name: string;
  legacyStoreId: number | string;
  projectId?: number;
  lat: number | null;
  lon: number | null;
}

/**
 * The store the rep is standing at, if the day's surfaces put one within
 * `thresholdMiles` of their position — or null. Null means "don't know",
 * never "probably": the caller asks the rep instead of assuming a status.
 * calculateDistance returns MILES (dayLegs R = 3959); the default is
 * ~200 meters.
 */
export function storeAtHand(
  userLoc: { lat: number; lng: number } | null,
  stores: TodayStoreRef[],
  thresholdMiles = 0.125,
): TodayStoreRef | null {
  if (!userLoc) return null;
  let best: TodayStoreRef | null = null;
  let bestMiles = Infinity;
  for (const s of stores) {
    if (s.lat == null || s.lon == null) continue;
    const miles = calculateDistance(userLoc.lat, userLoc.lng, s.lat, s.lon);
    if (miles < bestMiles) {
      bestMiles = miles;
      best = s;
    }
  }
  return bestMiles <= thresholdMiles ? best : null;
}
